import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { MainData } from "IF/interfaceType";
import { UserData } from "IF/userSession";
import { API_BASE_URL } from "Utils/apiUtil";

// export const fetchData = createAsyncThunk(
//   "data/fetchData",
//   async (userData: UserData) => {
//     if (userData.companyCode) {
//       const response = await axios.get(`${API_BASE_URL}/Main`, {
//         params: { schema: userData.companyCode },
//       });
//       return response.data;
//     }
//   }
// );

export const fetchData = createAsyncThunk(
  "data/fetchData",
  async (userData: UserData) => {
    if (userData.companyCode) {
      const response = await axios.get(`${API_BASE_URL}/Main`, {
        params: { schema: userData.companyCode },
      });

      console.log("=== API /Main response debug ===");
      console.log(response.data);

      response.data.serialNoDataList.forEach((panel: any) => {
        panel.dashboardDataList.forEach((worker: any) => {
          const tagId = String(worker.tagId ?? "");

          if (tagId.includes("B") || tagId.includes("~")) {
            console.log(
              "API tagId =",
              tagId,
              Array.from(tagId).map((c) => c.charCodeAt(0))
            );
          }
        });
      });

      return response.data;
    }
  }
);


interface DataState {
  data: MainData;
  loading: boolean;
  error: string | null;
}

const initialState: DataState = {
  data: {
    serialNoDataList: [],
    areaNameDataList: [],
  },
  loading: false,
  error: null,
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "";
      });
  },
});

export const dataReducer = dataSlice.reducer;
